// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__d7dQ8","menuList":"Menu_menuList__Sn5ja","menuItem":"Menu_menuItem__l95NT"};